import { Form, Modal, Select, message } from 'antd';
import { useEffect, useState } from 'react';
import { authRequest } from '../../../../common/request/authRequest';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { DrawerPanelTitle, modalPanelStyles } from '../../common/Drawers/DrawerPanelTitle';

type EmailRecipientsModalProps = {
	visible: boolean;
	emails: string[];
	onClose: () => void;
	onSaved: (emails: string[]) => void;
};

export const EmailRecipientsModal = ({ visible, emails, onClose, onSaved }: EmailRecipientsModalProps) => {
	const { projectGroup } = useAuth();
	const [form] = Form.useForm<{ emails: string[] }>();
	const [isSaving, setIsSaving] = useState(false);

	useEffect(() => {
		if (visible) {
			form.setFieldsValue({ emails });
		}
	}, [visible, emails, form]);

	const onFinish = async (values: { emails: string[] }) => {
		const updatedEmails = values.emails ?? [];

		setIsSaving(true);
		try {
			await authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/alert-config/emails`, {
				method: 'PATCH',
				data: { emails: updatedEmails },
			});
			onSaved(updatedEmails);
			message.success('Destinatarios guardados correctamente');
			onClose();
		} catch {
			message.error('Error al guardar los destinatarios');
		} finally {
			setIsSaving(false);
		}
	};

	return (
		<Modal
			open={visible}
			okText='Guardar'
			cancelText='Cancelar'
			confirmLoading={isSaving}
			onOk={() => form.submit()}
			onCancel={onClose}
			afterClose={() => form.resetFields()}
			destroyOnClose
			{...modalPanelStyles}
			title={<DrawerPanelTitle title="Gestionar destinatarios" />}
		>
			<Form form={form} layout='vertical' onFinish={onFinish} autoComplete='off'>
				<Form.Item
					label='Correos'
					name='emails'
					rules={[
						{
							validator: async (_, value: string[]) => {
								if (value?.length) {
									const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
									const invalidEmails = value.filter((email) => !emailRegex.test(email));
									if (invalidEmails.length > 0) {
										return Promise.reject(new Error('Hay correos con formato inválido'));
									}
								}
								return Promise.resolve();
							},
						},
					]}
				>
					<Select
						mode='tags'
						style={{ width: '100%' }}
						placeholder='Escribe un email y pulsa Enter'
						tokenSeparators={[',', ' ']}
						notFoundContent={null}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};
